
// let baseUrl = "https://un30test.fresenius-kabi-sspc.com/";
// let onAuthUrl ="https://apitest.fresenius-kabi-sspc.com/"

let baseUrl = "https://un.fresenius-kabi.com.cn/";
let onAuthUrl ="https://api.fresenius-kabi.com.cn/"


//接口
const ApiUrls = {
  Path:baseUrl+'Mobile/',
  baseUrl: baseUrl,
  onAuthUrl:onAuthUrl,
  imageUrl: baseUrl+'Files/img/',
  AUTH_TOKEN: baseUrl + 'api/token',
  LOGIN_GETLOGINURL: baseUrl + 'api/Login/GetLoginUrl',
  USER_GETUSERTODO: baseUrl + 'api/APPAPI/GetUserToDo',
  APPMANAGE_GETWORKSPACE: baseUrl + 'api/appmanage/GetWorkspace',
  APPMANAGE_GETAPPNOTICEBOARDLIST: baseUrl + 'api/appmanage/GetAPPNoticeBoards',
  APPMANAGE_SAVEMODULEVISITLOG: baseUrl + 'api/appmanage/SaveModuleVisitLog',
  APPAPI_LOGIN: baseUrl + 'api/appapi/Login',
  APPAPI_GETREDIRECTURL: baseUrl + 'api/appapi/GetRedirectUrl',
  APPAPI_GetFile: baseUrl + 'api/appapi/GetFile',

};

export default ApiUrls
